<template>
  <div>
    <wc-data-box
        :color="hasResolution"
        mini
        title='Resolution'
        showHelp
        :helpText='helpText'
    >
    <template v-slot:prependToolbarButtons>
      <v-btn v-if='!wo.archived && !wo.office_complete' small icon @click='edit'>
        <v-icon color='grey lighten-1'>mdi-pencil-outline</v-icon>
      </v-btn>
    </template>
      <v-card-text style='white-space: pre-wrap;'>{{ wo.resolution }}</v-card-text>
    </wc-data-box>

    <wc-dialog
      :showDialog='showEditDialog'
      title='Resolution'
      @cancel='cancel'
      @save='update'
    >
      <template v-slot:toolbarButtons>
        <v-tooltip top :disabled='alreadyAppended'>
          <template v-slot:activator='{ on }'>
            <div v-on='on' class='d-inline-block'>
              <v-btn
                small
                text
                color='white'
                elevation='0'
                :disabled='noTasksCompleted || alreadyAppended'
                @click='appendLabourDescriptions'
              >
                <v-icon left>mdi-text-box-plus-outline</v-icon>
                Append Labour Descriptions
              </v-btn>
            </div>
          </template>
          <span>{{ noTasksCompleted ? "There are no task descriptions for this work order" : "Add all labour line descriptions into this dialog"}}</span>
        </v-tooltip>
      </template>
      <v-textarea
        v-model='woCopy.resolution'
        outlined
        auto-grow
        rows='10'
      ></v-textarea>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'wo-resolution',
  props: {
    wo: {
      required: true
    },
    labourLines: {
      required: false,
      type: Array,
    }
  },
  data: () => ({
    isLoading: false,
    showEditDialog: false,
    alreadyAppended: false,
    woCopy: {},
    helpText: "The default resolution is automatically added here when the work order is loaded. The default resolution text can be set for each work order type in the settings app.<br><br>Try the append button in the edit dialog to quickly paste all the labour descriptions for easy editing!"
  }),
  computed: {
    hasResolution(){
        console.log(this.wo.resolution);
        if(!this.wo.resolution || this.wo.resolution === ""){
            return "error"
        }
        else{
            return "grey lighten-4"
        }
    },
    noTasksCompleted () {
      return this.labourLines ? false : true
    }
  },
  methods: {
    edit () {
      this.woCopy = _.cloneDeep(this.wo)
      this.showEditDialog = true
    },
    update () {
      this.$emit('update', this.woCopy)
      this.alreadyAppended = false
      this.showEditDialog = false
    },
    appendLabourDescriptions() {
      this.alreadyAppended = true
      this.labourLines.forEach(l => this.woCopy.resolution = this.woCopy.resolution === null ? l.task_completed : (this.woCopy.resolution + '\r\n' + l.task_completed))
    },
    cancel () {
      this.showEditDialog = false
      setTimeout(() => {
        this.alreadyAppended = false
      }, 500)
    }
  }
}
</script>